import { render } from "./BestInShow.vue?vue&type=template&id=f6141dd2"
import script from "./BestInShow.vue?vue&type=script&lang=ts"
export * from "./BestInShow.vue?vue&type=script&lang=ts"
script.render = render

export default script